export default {
  all_overall_list_table: {
    results: [],
  },
  all_clients_by_income: {
    results: [],
  },
  all_clients_table: {
    results: [],
  },
  not_sold_flat: {
    results: [],
  },
  sold_flat: {
    results: [],
  },
  overall_table: {
    results: [],
  },
  objects: [],
  single_object: {
    video: [],
    links: [],
    payment_type: [],
    bank: {},
    parking: [],
  },
  reports: [],
  object_types: {
    results: [
      {
        id: 1,
        name: {
          uz: 'Turar-joy',
          ru: 'Жилой комплекс',
        },
      },
      {
        id: 2,
        name: {
          uz: 'Kvartal',
          ru: 'Квартал',
        },
      },
    ],
  },
  object_infrastuctures: {
    results: [],
  },
  parking_options: {
    results: [
      {
        id: 2,
        title: {
          ru: 'Нет',
          uz: "Yo'q",
        },
      },
      {
        id: 3,
        title: {
          ru: 'Подземная',
          uz: 'Yer osti',
        },
      },
      {
        id: 4,
        title: {
          ru: 'Наземная',
          uz: 'Yer usti',
        },
      },
    ],
  },
  object_calculations: [],
  construction_progress: [],
  price_history: {
    results: [],
    count: 0,
  },
  discount_history: {
    results: [],
    count: 0,
  },
  payment_types: {
    results: [],
  },
  single_payment_type: {},
  relatedPerson: [],
}
